document.addEventListener(
  'DOMContentLoaded',
  function () {
    const jumpList = document.querySelectorAll('.jump-list');
    document.addEventListener('click', () => {
      jumpList.forEach((el) => {
        el.classList.remove('is-open');
      });
    });

    jumpList.forEach((el) => {
      el.querySelector('.jump-list__title').addEventListener('click', (e) => {
        e.stopPropagation();
        el.classList.toggle('is-open');
      });
    });
  },
  false
);
